import useSWRImmutable from "swr/immutable";
import { refreshToken } from "shared/lib/account/apis";
import { JWTExpiryThreshold, JWTRefreshSWRKey } from "shared/lib/account/consts";
import { getAccountState } from "shared/lib/account/helpers";
export const useRefreshToken = () => {
  const {
    isLoggedIn,
    pianoUser,
    user
  } = getAccountState();
  const isJWTExpired = () => {
    // Confirm the expiry time is the latest value instead of the initial value.
    const {
      accessTokenExpiryTime
    } = getAccountState();
    return ((accessTokenExpiryTime ?? 0) - JWTExpiryThreshold) * 1000 - Date.now() < 0;
  };
  const isNeedToRefreshToken = () => !!user && (!pianoUser || !user.source || !user.created || !user.useremail || !user.uuid || user.useremail !== pianoUser.email || user.uuid !== pianoUser.sub);
  useSWRImmutable(() => isLoggedIn ? JWTRefreshSWRKey : null, refreshToken, {
    isPaused: () => !(isNeedToRefreshToken() || isJWTExpired()),
    refreshInterval: 5000,
    revalidateOnMount: true
  });
};